// extracted by mini-css-extract-plugin
module.exports = {"wide":"styles_wide__2E_Lo","btnMenu":"styles_btnMenu__UlO_Y","btn":"styles_btn__1rQPC","open":"styles_open__3nF0f","logo":"styles_logo__2d3nW"};